function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/) );
requireAll( require.context( './fonts/', true ) );
requireAll( require.context( './admin-thumbs/', true, /\.png$/) );
//requireAll( require.context( './png/', true, /\.png$/) );
//requireAll( require.context( './gif/', true, /\.gif$/) );

import $ from 'jquery';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import Headroom from 'headroom.js';
import { CountUp } from 'countup.js';
import tabsList from '../../../../../vendor/tabsspaces/tabslist/src/assets/tabsList.js';
import { WordUp } from './js/wordup.js';
import { Odometer } from 'odometer_countup';


window.jQuery = $;
window.$ = $;


$(function () {

	var PROJECT = {

		common: {

			getViewport: function() {

				var viewPortWidth;
				var viewPortHeight;

				if (typeof window.innerWidth !== 'undefined') {

					viewPortWidth = window.innerWidth;
					viewPortHeight = window.innerHeight;

				} else if ( typeof document.documentElement !== 'undefined' &&
							typeof document.documentElement.clientWidth !== 'undefined' &&
							document.documentElement.clientWidth !== 0 ) {

					viewPortWidth = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;

				} else {

					viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
					viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
				}

				return { width : viewPortWidth , height : viewPortHeight };

			},

			fixWidth: function( elm ) {

				const items = document.querySelectorAll( elm );

				// Set width after first paint
				requestAnimationFrame(() => {
					items.forEach(item => {
						
						item.style.width = `${item.offsetWidth}px`;
						// console.log( item.offsetWidth )
					});
				});

				// Reset on resize
				window.addEventListener('resize', () => {
					items.forEach(item => {
						item.style.width = ''; // clear inline style, let grid recalculate
					});

					// Re-lock after grid has recalculated
					requestAnimationFrame(() => {
						items.forEach(item => {
							item.style.minWidth = `${item.offsetWidth}px`;
							// console.log( 'resize %s', item.offsetWidth );
						});
					});
				});
			

			},

			init: function () {

				PROJECT.nav.init();

				PROJECT.toggle.init();

				PROJECT.gform.init();

				PROJECT.list.init();
				
				// PROJECT.accordion.init();

				PROJECT.carousels.init();

				PROJECT.countup.init();

				PROJECT.wordup.init();

				PROJECT.grid.init();

			}

		},

		toggle: {

			/*
			 * Toggle Text in Button label
			 * Used in jsnNavToggle
			 */

			clickElm: '.jsToggleText',
			labelElm: '.jsToggleTextLabel',
			dataAttr: 'toggle-text',

			init: function() {

				$( document ).on( 'click', PROJECT.toggle.clickElm, PROJECT.toggle.switch );

			},

			switch: function( e ) {

				let $elm =  $( this );

				let $label = $elm.find( PROJECT.toggle.labelElm );

				let toggleText = $elm.data( PROJECT.toggle.dataAttr );

				let currentText = $label.text();

				let newText = currentText == toggleText.current ? toggleText.toggle : toggleText.current;

				$label.text( newText );

				$elm.attr( 'title', newText );

			}

		},

		nav: {

			/*
			 * Toggle Core Nav Visibility
			 * - Sets a css class on html elmement
			 * - Disable tabsindex when menu is closed
			 * - Click and Key controlled
			 */


			mainElm: '.navMain',
			clickElm: '.jsNavToggle',
			openClass: 'state-c-header--nav-open',


			init: function() {

				PROJECT.nav.sticky();

				$( document ).on( 'click', PROJECT.nav.clickElm, PROJECT.nav.toggle );

				$( document ).on( 'keyup', PROJECT.nav.esc );

				$( PROJECT.nav.mainElm + ' a' ).each( function() {

					$( this ).attr('tabindex', -1 );

				});


				
				// WCAG Dropdown Submenu
				var toggles = document.querySelectorAll( '.sub-menu-toggle' );

				if ( ! toggles.length ) return;

				// Initialise: mark all toggles as collapsed and remove sub-menu
				// links from the tab order so closed menus are unreachable by Tab.
				toggles.forEach( function( toggle ) {

					var li      = toggle.parentNode;
					var subMenu = li ? li.querySelector( '.sub-menu' ) : null;

					toggle.setAttribute( 'aria-expanded', 'false' );

					if ( subMenu ) {
					
						
						PROJECT.nav.setTabIndex( subMenu, '-1' );
					}

				} );

				$( document ).on( 'click', '.v-nav--mobile > .v-nav__item--has-children > .sub-menu-toggle', PROJECT.nav.toggleSubmenu );

				// Click outside any open menu → close all.
				$( document ).on( 'click', PROJECT.nav.clickOutside );

				$( document ).on( 'keydown', PROJECT.nav.keyBoard );

				$( document ).on( 'focusout', PROJECT.nav.focusOut );		

			},

			toggle: function() {

				if ( $( 'body' ).hasClass( PROJECT.nav.openClass ) ) {

					PROJECT.nav.close();

				} else {

					PROJECT.nav.open();
				}
			},

			esc: function( e ) {

				if ( e.keyCode === 27 ) {

					PROJECT.nav.close();

				}
			},

			open: function() {

				$( 'body' ).addClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm + ' a').each( function() {

					$( this ).removeAttr('tabindex', -1 );

				});

			},

			close: function() {

				$( 'body' ).removeClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm  + ' a' ).each( function() {

					$( this ).attr('tabindex', -1 );

				});

			},

			sticky: function() {

				var body = $( 'body' ).get( 0 );

				var headerSticky = new Headroom( body, {

					offset: 100,
					tolerance : {

						up : 5,
						down : 0

					},
					classes : {

						initial : "state-c-header",
						pinned : "state-c-header--pinned",
						unpinned : "state-c-header--unpinned",
						top : "state-c-header--top",
						notTop : "state-c-header--not-top",
						bottom : "state-c-header--bottom",
						notBottom : "state-c-header--not-bottom"

					},

				});

				headerSticky.init();

			},



			/**
			 * Set tabindex on every focusable element inside a sub-menu.
			 * '-1' → unreachable by Tab (closed state)
			 * '0'  → reachable by Tab  (open state)
			 */
			setTabIndex: function( subMenu, value ) {

				subMenu.querySelectorAll( 'a, button, [tabindex]' ).forEach( function( el ) {

					el.setAttribute( 'tabindex', value );

				} );

			},


			openMenu: function( toggle ) {

				var li      = toggle.parentNode;
				var subMenu = li ? li.querySelector( '.sub-menu' ) : null;

				if ( ! li || ! subMenu ) return;

				toggle.setAttribute( 'aria-expanded', 'true' );

				li.classList.add( 'v-nav__item--open' );

				PROJECT.nav.setTabIndex( subMenu, '0' );

			},


			closeMenu: function( toggle, returnFocus ) {

				var li      = toggle.parentNode;
				var subMenu = li ? li.querySelector( '.sub-menu' ) : null;

				if ( ! li || ! subMenu ) return;

				toggle.setAttribute( 'aria-expanded', 'false' );

				li.classList.remove( 'v-nav__item--open' );

				PROJECT.nav.setTabIndex( subMenu, '-1' );

				if ( returnFocus ) toggle.focus();

			},


			closeAll: function( except ) {

				document.querySelectorAll( '.sub-menu-toggle[aria-expanded="true"]' ).forEach( function( toggle ) {				

					if ( toggle !== except ) PROJECT.nav.closeMenu( toggle );

				} );

			},


			toggleSubmenu: function( e ) {			

				if ( ! e ) return;

				var toggle = e.target.closest( '.sub-menu-toggle' );

				if ( ! toggle ) return;

				console.log( toggle );				

				var isOpen = toggle.getAttribute( 'aria-expanded' ) === 'true';

				PROJECT.nav.closeAll( toggle ); // close sibling sub-menus first

				if ( isOpen ) {
					PROJECT.nav.closeMenu( toggle );
				} else {
					PROJECT.nav.openMenu( toggle );
				}

			},


			// Separate handler for clicks outside — toggleSubmenu is bound only to
			// the toggle button so the "click outside" check would never be reached there.
			clickOutside: function( e ) {

				if ( ! e ) return;

				if ( ! e.target.closest( '.v-nav__item--has-children' ) ) {

					PROJECT.nav.closeAll();

				}

			},


			keyBoard: function( e ) {

				if ( ! e ) return;

				if ( e.key !== 'Escape' ) return;

				// Space / Enter on <button> fire as native click events — no need to
				// handle them here.

				if ( ! document.activeElement ) return;

				// Find the nearest open toggle relative to the currently focused element.
				// This works whether focus is on the toggle itself or on a sub-menu link.
				var li = document.activeElement.closest( '.v-nav__item--item-has-children' );

				if ( ! li ) return;

				var nearestOpen = li.querySelector( '.sub-menu-toggle[aria-expanded="true"]' );

				if ( nearestOpen ) {

					PROJECT.nav.closeMenu( nearestOpen, true );

				} else {

					// Fallback: close any open toggle.
					var anyOpen = document.querySelector( '.sub-menu-toggle[aria-expanded="true"]' );

					if ( anyOpen ) PROJECT.nav.closeMenu( anyOpen, true );

				}

			},


			focusOut: function( e ) {

				if ( ! e ) return;

				var li = e.target.closest( '.v-nav__item--has-children' );

				if ( ! li ) return;

				// e.relatedTarget is the element that is receiving focus.
				// If it is still inside the same <li> (toggle or a sub-menu link)
				// the user is tabbing within the menu — keep it open.
				// null relatedTarget means focus left the page entirely — close the menu.
				if ( e.relatedTarget && li.contains( e.relatedTarget ) ) return;

				var toggle = li.querySelector( '.sub-menu-toggle' );

				if ( toggle ) PROJECT.nav.closeMenu( toggle );

			},

		},

		gform: {

			init: function() {

				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );

				$( document ).on( 'click.loader', '.gform_button', PROJECT.gform.showLoader );
				$( document ).on( 'click.loader', '.gform_next_button, gform_previous_button', PROJECT.gform.showLoader );
				$( document ).on( 'submit', '.gform_wrapper form', PROJECT.gform.showLoader );

				$( document ).on( 'gform_page_loaded', PROJECT.gform.hideLoader );

				$( document ).on( 'gform_confirmation_loaded', PROJECT.gform.showConfirmation );
				$( document ).on( 'click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation );


				$( document ).on( 'focus', 'input, textarea, select', function() {
					$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
				});

				$( document ).on( 'blur', 'input, textarea, select', function( e ) {
					if( !$(this).val() ) {
						$( this ).parents( '.gfield' ).removeClass( 'state--has-focus' );
					}
				});

				PROJECT.gform.fixHasFocus();

			},

			fixHasFocus: function() {

				$( 'input, textarea, select' ).each(function() {

					if( $(this).val() ) {
						$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
					}

				});

			},

			showLoader: function() {

				var $gformContainer = $(this).closest( '.gformContainer' );
				var $gformLoader = $gformContainer.find( '.gformLoader' );

				$gformLoader.fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideLoader: function() {

				$( '.gformLoader' ).fadeOut( 300 );

			},

			showConfirmation: function() {

				$( '.gformConfirmation' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideConfirmation: function() {

				$( '.gformConfirmation' ).fadeOut( 300 );

			}

		},

		list: {

			// Only for project based code.
			init:function() {}

		},

		// accordion:{

		// 	init: function() {

		// 		$( document ).off( 'click', '.v-nav--mobile .v-nav__item--has-children > a' );
		// 		$( document ).on( 'click', '.v-nav--mobile .v-nav__item--has-children > a', {

		// 			class: 'v-nav__item--open',
		// 			classElement: '.v-nav__item',
		// 			toggleElement: '.sub-menu',

		// 		}, PROJECT.accordion.toggle );

		// 	},
		// 	toggle: function ( e ) {

		// 		e.preventDefault();

		// 		var parent = $( this ).closest( e.data.classElement );
		// 		var isOpen = $( parent ).hasClass( e.data.class );

		// 		$( '.v-nav--mobile ' + e.data.classElement ).removeClass( e.data.class );
		// 		if ( e.data.toggleElement !== '' ) {
		// 			$( '.v-nav--mobile ' + e.data.classElement ).find( e.data.toggleElement ).stop().slideUp( 250 );
		// 		}

		// 		if ( !isOpen ) {

		// 			$( parent ).addClass( e.data.class );

		// 			if ( e.data.toggleElement !== '' ) {

		// 				$( parent ).find( e.data.toggleElement ).stop().slideDown( 250 ).css({
		// 					display: "flex"
		// 				});

		// 			}

		// 		}

		// 	},
		// },
		
		countup: {

			figureElm: '.jsViewFigures',
			numberElm: '.jsCountUpNum',
			figureValueElm: '.jsFigureValue',

			init: function() {
				
				if ( document.querySelectorAll( PROJECT.countup.figureElm ).length > 0 ) {
				

					PROJECT.countup.fixWidths();
					

					PROJECT.countup.counterUp();

				}

			},

			fixWidths: function() {
				const figures = document.querySelectorAll( PROJECT.countup.figureElm );

				figures.forEach( function( el ) {
					const figureValues = el.querySelectorAll( PROJECT.countup.figureValueElm );

					figureValues.forEach( function( figureValue ) {

						const width = figureValue.offsetWidth;
						figureValue.style.width = width + 'px';

					});

				});
			},

			counterUp: function() {
				var $numbers = $('.jsCountUpNum');

				if ($numbers.length > 0) {
					$numbers.each(function() {

						
						var animCounter = '';						
						var counter = $(this).attr('data-countup-num');
						var decimalTotal = 0;
						if (counter.indexOf('.') > -1) {
							decimalTotal = counter.split('.')[1].length;
						}

						var prefix = $(this).attr('data-countup-prefix') || '';
						var suffix = $(this).attr('data-countup-suffix') || '';

						// Clear the content before animation
						$(this)[0].textContent = '';

						animCounter = parseFloat(counter.toString().replace(/,/g, ''));

						const countUp = new CountUp(this, animCounter, {
							separator: ',',
							decimal: '.',
							autoAnimateDelay: 1200,
							//prefix: prefix, > use Plugin
							//suffix: suffix, > use Plugon
							decimalPlaces: decimalTotal,
							enableScrollSpy: true,
							scrollSpyOnce: true,
							// plugin: new Odometer({ duration: 2, lastDigitDelay: 0 })								
							// plugin: new countUpPluginPreSuffixWrap({ prefix: prefix, suffix: suffix, prefixClass: 'v-figures__prefix', suffixClass: 'v-figures__suffix' }),
						});
					});
				}
			},
		},

		wordup: {
			init: function() {
				
				PROJECT.wordup.wordsup();

			},

			wordsup: function() {

				var wordUp = new WordUp( '.jsWordUp', {
					speed: 1800,
					animDur: 600, 
					transition: 'typewriter',
					animateFirst: true,
					enableScrollSpy: true,
					scrollSpyOnce: true,

				} );
			}
		
		},

		carousels: {

			init: function() {

				PROJECT.carousels.blocksCarousel();

			},

			blocksCarousel: function() {

				const carousels = document.querySelectorAll('.jsBlocksCarousel');

				if( carousels.length < 0 ) return false;

				carousels.forEach( function( el ) {

					let carousel  = el.querySelector( '.swiper' );
					let pagination =  el.querySelector( '.jsCarouselPagination' );

					if( carousel === null ) return false;

					const swiper = new Swiper( carousel, {

						modules: [ Pagination ],

						slidesPerView: 'auto',
						spaceBetween: 0,

						watchOverflow: true,
						// centeredSlidesBounds: true,

						pagination: {
							el: pagination,
							type: 'bullets',
							clickable: true,
						},

					});

					el.instanceSwiper = swiper;

				});

			}

		},

		grid: {

			elm: '.jsGridWrapper',

			container: null,

			init: function() {

				PROJECT.grid.container = document.querySelector( PROJECT.grid.elm );

				const ro = new ResizeObserver( PROJECT.grid.wrapper );

				ro.observe( PROJECT.grid.container );

			},

			wrapper: function() {

				const isOverflowing = PROJECT.grid.container.scrollWidth > PROJECT.grid.container.clientWidth;

				if ( isOverflowing ) {
					PROJECT.grid.container.classList.addClass('flex-wrap');
				}
			}

		},

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);

});


class countUpPluginPreSuffixWrap {
  constructor({ prefix = '', suffix = '', prefixClass = '', suffixClass = '' } = {}) {
    this.prefix = prefix;
    this.suffix = suffix;    
    this.prefixClass = prefixClass;
    this.suffixClass = suffixClass;
  }

  isPunctuation(str) {
    return /^\p{P}+$/u.test(str.trim());
  }

  render(elem, formatted) {
    
    const prefixPunctuationClass = this.isPunctuation(this.prefix) ? ' is-punctuation-only' : '';
    const suffixPunctuationClass = this.isPunctuation(this.suffix) ? ' is-punctuation-only' : '';

    elem.innerHTML = 
      `<span class="${this.prefixClass}${prefixPunctuationClass}">${this.prefix}</span>` +
      formatted +
      `<span class="${this.suffixClass}${suffixPunctuationClass}">${this.suffix}</span>`;;
  }
}